import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const SimpleModalHTML: FC = () => {
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);

  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );

  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const btnFontURL = getFontURL(btnFontFamily?.button);
  const neverShowBtnFontURL = getFontURL(btnFontFamily?.never_show_button);

  const closeImageUrl = 'https://image.inappmessage.com/sample/xmark-1.png';
  const style = `
  @Font-face {
    font-family:'btn';
    src: url(${btnFontURL});
  }
  @Font-face {
    font-family: 'never_show_btn';
    src: url(${neverShowBtnFontURL});
  }
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
        width: 100%;
        height: 100%;
        
        position: relative;
        background: none;
        overflow: hidden;
    }
    
    .close_btn {
        position: absolute;
        right: 10%;
        top: 6%;
    }
    .close_btn button {
        width: 1.5rem;
        height: 1.5rem;
        
        background-image: url(${closeImageUrl});
        background-repeat: no-repeat;
        background-size: 1.5rem;
        background-position: center;

        font-size: 0;
        border: none;
        background-color: transparent;
    }

    .background {
        width: 100%;
        height: 100%;

        position: absolute;
        top: 0;
        background: rgba(0, 0, 0, ${displayValue});
    }
    .center {
        width: 290px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        display: flex;
        flex-direction: column;
        gap: 0.5rem;
    }
    .modal_wrapper {
        width: 100%;
        height: 435px;
        padding: 2rem 1rem;

        border-radius: ${radius?.background}px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        position: relative;
        ${
          bgImage?.background || bgImage?.background !== ''
            ? `background-image: url(${bgImage?.background})`
            : 'background: rgba(0, 0, 0, 0.8)'
        };        
    }

    .btn_wrapper {
        width: calc(100% - 2rem);
        position: absolute;
        bottom: 2rem;
    }
    .btn_wrapper button {
        width: 100%;
        height: 2.6rem;
        outline: 0;
        border: 0;

        font-size: ${btnFontSize?.button}rem;
        font-weight: ${btnFontWeight?.button};
        color: ${btnColor?.button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            btnFontFamily?.button
          )
            ? btnFontFamily?.button
            : 'btn'
        };

        border-radius: ${radius?.button}px;
        background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
    }

    .bottom_wrapper {
        width: 100%;
        height: 2.6rem;

        display: flex;
        align-items: center;
        justify-content: center;

        text-align: center;
        font-size: ${btnFontSize?.never_show_button}rem;
        font-weight: ${btnFontWeight?.never_show_button};
        color: ${btnColor?.never_show_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            btnFontFamily?.never_show_button
          )
            ? btnFontFamily?.never_show_button
            : 'never_show_btn'
        };
        border-radius: ${radius?.never_show_button}px;
        background-color:rgba(${btnBgColorR?.never_show_button},${
    btnBgColorG?.never_show_button
  }, ${btnBgColorB?.never_show_button}, ${btnBgColorA?.never_show_button});
    }
  `;

  const html = `
    <div class="root">
        <div class="background"></div>
        <div class="close_btn">
            <button>close</button>
        </div>
        <div class="center">
            <div class="modal_wrapper">
                <div class="btn_wrapper">
                    <button>${btnText?.button}</button>
                </div>
            </div>
            <div class="bottom_wrapper">${btnText?.never_show_button}</div>
        </div>
    </div>
  `;

  let tracking_list = '[';
  for (let i = 0; i < tracking?.background?.length; i++) {
    tracking_list += `['${tracking?.background?.[i]}', '${tracking?.button?.[i]}', '${tracking?.sub_button?.[i]}', '${tracking?.never_show_button?.[i]}'],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList('SIMPLE MODAL', button1, button2);

  const js = `
  document.addEventListener("DOMContentLoaded", function(){
    let tracking = ${tracking_list};
    let button1 = ${tracking_button_list[0]};
    let button2 = ${tracking_button_list[1]};
    $('.modal_wrapper').click(function() {
      appboyBridge.logClick(tracking[0][0]);
      try {
        if (button1[0].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[0].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = '${deeplink?.background}';
    });
    $('.btn_wrapper').click(function(event) {
      event.stopPropagation();
      appboyBridge.logClick(tracking[0][1]);
      try {
        if (button1[1].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[1].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = '${deeplink?.background}';
    });
    $('.close_btn').click(function() {
      appboyBridge.logClick(tracking[0][2]);
      try {
        if (button1[2].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[2].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      appboyBridge.closeMessage();
    });
    $('.bottom_wrapper').click(function() {
      try {
        if ("${btnAgain?.type}" === "attribute") {
          appboyBridge.getUser().setCustomUserAttribute("${btnAgain?.never_show_button}", new Date());
        }
        if ("${btnAgain?.type}" === "event") {
          appboyBridge.logCustomEvent("${btnAgain?.never_show_button}");
        }
      } catch (err) {}

      appboyBridge.logClick(tracking[0][3]);
      try {
        if (button1[3].indexOf(0) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[3].indexOf(0) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      appboyBridge.closeMessage();
    });
  });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};
export default SimpleModalHTML;
